import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from 'app/global/global.service';
import {OrganizationService} from '../../contacts/organizations/organization.service';

@Component({
  selector: 'app-organization-modal',
  templateUrl: './organization-modal.component.html',
  styleUrls: ['./organization-modal.component.scss']
})
export class OrganizationModalComponent implements OnInit {
  @Input() organization: string;
  public submitted: boolean = false;
  public loader: boolean = false;
  public organizationForm: UntypedFormGroup;

  /**
   * Contructor
   * @param organizationService
   * @param formBuilder
   * @param globalService
   * @param activeModal
   * @param _translocoService
   */
  constructor(
    private organizationService: OrganizationService,
    private formBuilder: UntypedFormBuilder,
    private globalService: GlobalService,
    public activeModal: NgbActiveModal,
    private _translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this.initOrganizationForm(this.organization);
  }


  /**
    * Init organization form
    */
  initOrganizationForm(organization) {
    this.organizationForm = this.formBuilder.group({
      name: [organization ?? '', [Validators.required]],
      register_no: [''],
      phone: [''],
      address: [''],
      zipcode: [''],
      city: ['']
    });
  }



  /** Close active modal */
  closeModal() {
    this.activeModal.close()
  }


  /** FormControls */
  get form() {
    return this.organizationForm.controls;
  }


  /**
 * Create and connect organization with contract
 * @returns array
 */
  async createOrganization() {
    this.submitted = true;
    if (this.organizationForm.invalid) {
      return;
    }
    this.loader = true;
    this.organizationService.addOrganization(this.organizationForm.value).subscribe({
      next: (response) => {
        this.submitted = false;
        this.loader = false;
        this.globalService.toastrSuccess(this._translocoService.translate('Create organization success toast message - (Organization modal) - Organization has been created'));
        this.activeModal.close(response);
      },

      error: (error) => {
        this.submitted = false;
        this.loader = false;
        this.globalService.toastrError(error);
      }
    })
  }

}
